import { cn } from '@platform/ui';

export const BRAND_NAME = 'Metamindia';

/**
 * Logo de Metamindia (tomado de metamindia.com). `tone="light"` es el original en blanco, para
 * fondos azul noche; `tone="ink"` es la versión en azul noche para fondos claros.
 */
export function BrandLogo({
  tone = 'light',
  className,
}: {
  tone?: 'light' | 'ink';
  className?: string;
}) {
  return (
    <img
      src={`/brand/metamindia-logo-${tone}.png`}
      alt={BRAND_NAME}
      width={268}
      height={96}
      className={cn('h-9 w-auto select-none', className)}
      draggable={false}
    />
  );
}

/** Sólo el isotipo (la "M" de circuito). */
export function BrandMark({
  tone = 'light',
  className,
}: {
  tone?: 'light' | 'ink';
  className?: string;
}) {
  return (
    <img
      src={`/brand/metamindia-mark-${tone}.png`}
      alt=""
      aria-hidden
      width={128}
      height={127}
      className={cn('size-8 select-none', className)}
      draggable={false}
    />
  );
}
